// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"Sidebar__sidebar___3X-DF","footer":"Sidebar__footer___lMsav"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/Sidebar.scss
// module id = 104
// module chunks = 0